import React from "react";
import { useRestaurant } from "../../context/RestaurantContext";

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const Footer = () => {
  const { restaurantSettings, formatTime } = useRestaurant();
  const today = restaurantSettings?.todayHours;
  const closedDays = (restaurantSettings?.weeklyHours || []).filter(h => !h.isOpen).map(h => DAY_NAMES[h.day]);

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ color: "#0B9444" }}>
              GutfulGoodness
            </h3>
            <p className="text-gray-600 text-sm">
              Delivering delicious food from our three premium brands across
              Nagpur.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-800">Our Brands</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>Gutful Goodness - Greens - Fitness Meals</li>
              <li>KEPSA QUEUE - Biryani</li>
              <li>GRAVY GANJ - North Indian</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-800">Contact Us</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>📧 gutfulgoodness@gmail.com</li>
              <li>📞 +91 77097 32049</li>
              <li>
                ⏰ {today?.isOpen === false
                  ? "Closed today"
                  : `${formatTime(today?.openingTime || "13:00")} - ${formatTime(today?.closingTime || "23:00")}`}
              </li>
              {closedDays.length > 0 && (
                <li className="text-red-500 font-semibold">
                  🚫 Closed on {closedDays.join(", ")}
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-6 text-center text-sm text-gray-600">
          <p>
            &copy; {new Date().getFullYear()} GutfulGoodness. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
